import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FeaturedPostCard from '../components/FeaturedPostCard';
import PostCard from '../components/PostCard';
import CategoryGrid from '../components/CategoryGrid';
import Sidebar from '../components/Sidebar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [featuredPost, setFeaturedPost] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);
  const [popularPosts, setPopularPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [postsRes, categoriesRes, popularRes] = await Promise.all([
        axios.get(`${API}/posts?limit=7`),
        axios.get(`${API}/categories`),
        axios.get(`${API}/posts/popular?limit=5`),
      ]);

      const posts = postsRes.data;
      if (posts.length > 0) {
        setFeaturedPost(posts[0]);
        setRecentPosts(posts.slice(1));
      }
      setCategories(categoriesRes.data);
      setPopularPosts(popularRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl font-bold" data-testid="loading-indicator">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      {featuredPost && (
        <section className="mb-16" data-testid="hero-section">
          <FeaturedPostCard post={featuredPost} />
        </section>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12">
        {/* Category Grid */}
        {categories.length > 0 && (
          <section className="py-16 sm:py-24">
            <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mb-12">
              Explore Categories
            </h2>
            <CategoryGrid categories={categories} />
          </section>
        )}

        {/* Recent Posts with Sidebar */}
        <section className="py-16 sm:py-24 border-t border-border">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
            <div className="lg:col-span-2" data-testid="recent-posts-section">
              <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mb-12">
                Latest Articles
              </h2>
              <div className="space-y-12">
                {recentPosts.map((post) => (
                  <PostCard key={post.id} post={post} />
                ))}
              </div>
            </div>

            <div className="lg:col-span-1" data-testid="sidebar-section">
              <div className="sticky top-24">
                <Sidebar popularPosts={popularPosts} categories={categories} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
